import React, { Fragment, useRef, useEffect } from 'react';
import NProgress from 'nprogress';
import { Helmet } from 'react-helmet';

import { useLocation } from 'react-router';
import { Content } from './Content';

export const IndexLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();

  const previousPath = useRef('');
  const currentPath = location.pathname + location.search;

  useEffect(() => {
    if (currentPath !== previousPath.current) {
      NProgress.start();
      const timer = setTimeout(() => {
        NProgress.done();
        previousPath.current = currentPath;
      }, 300);
      return () => {
        clearTimeout(timer);
      };
    }
    return undefined;
  }, [currentPath]);

  // Scroll to top on location change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <Fragment>
      <Helmet titleTemplate="Wahed Invest | %s" title="KYC Dashboard" />
      <Content location={location}>{children}</Content>
    </Fragment>
  );
};
